import React from "react";

const PrivacyPolicy  = () => {

    return(
        <div>
            <h1>Sage Salon Employee Task Management Privacy Policy</h1>
            <h2>Introduction</h2>
            <p>Sage Salon (the "App" or "we") is committed to protecting the privacy of our employees. This privacy policy outlines how we collect, use, and disclose information collected from employees using the Sage Salon employee task management app (the "App"). By using the App, you agree to the terms of this privacy policy.</p>

            <h2>Scope</h2>
            <p>This privacy policy applies to your use and navigation of the App, regardless of the medium by which the App is accessed by you.</p>

            <h2>Collection of Information</h2>
            <h3>Employee Information</h3>
            <p>When you create an account or use the App, we collect the following information:</p>
            <ul>
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Profile picture (optional)</li>
            </ul>

            <h3>Task Information</h3>
            <p>When you create or manage tasks through the App, we collect the following information:</p>
            <ul>
                <li>Task details (task name, description, due date, and status)</li>
                <li>Task assignments (assignee name and email)</li>
            </ul>

            <h3>Usage Data</h3>
            <p>We collect usage data, including:</p>
            <ul>
                <li>Device information (device type, operating system, and browser type)</li>
                <li>IP address</li>
                <li>Location data (city, state, and country)</li>
                <li>Search queries and browsing history</li>
            </ul>

            <h3>Communication</h3>
            <p>We collect communication data, including:</p>
            <ul>
                <li>Messages and emails sent through the App</li>
                <li>Phone calls and voice messages</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use your information for the following purposes:</p>
            <ul>
                <li>Task Management: We use your task information to manage tasks, including assigning tasks, tracking progress, and sending notifications.</li>
                <li>Improving the App: We use your usage data to improve the App, including optimizing the user experience and enhancing the functionality of the App.</li>
                <li>Communication: We use your communication data to send you notifications, updates, and other important information related to your tasks and the App.</li>
            </ul>

            <h2>Disclosure of Your Information</h2>
            <p>We may disclose your information to:</p>
            <ul>
                <li>Third-Party Service Providers: We may share your information with third-party service providers who assist us in providing the App, including data analytics providers and customer support services.</li>
                <li>Law Enforcement: We may disclose your information to law enforcement agencies or other government agencies if required by law or if necessary to protect our rights or the rights of others.</li>
            </ul>

            <h2>Security Measures</h2>
            <p>We take the security of your information seriously and use the following measures to protect it:</p>
            <ul>
                <li>Data Encryption: We use encryption to protect your information during transmission.</li>
                <li>Secure Servers: We store your information on secure servers that are protected by firewalls and access controls.</li>
                <li>Regular Backups: We regularly back up your information to ensure its availability and integrity.</li>
            </ul>

            <h2>Your Rights</h2>
            <p>You have the following rights regarding your information:</p>
            <ul>
                <li>Access: You have the right to access your information and request a copy of it.</li>
                <li>Correction: You have the right to request corrections to your information.</li>
                <li>Deletion: You have the right to request the deletion of your information.</li>
                <li>Withdrawal of Consent: You have the right to withdraw your consent to the processing of your information.</li>
            </ul>con

            <h2>Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. If we make significant changes to this policy, we will notify you through the App or by email.</p>


            <h2>Our app requires access to your location in the background to provide the following services:</h2>
            <ul>
                <li>Real-time navigation even when the app is not open.</li>
                <li>Location-based reminders and alerts.</li>
            </ul>
            <p>We are committed to protecting your privacy and use your location data only to enhance your user experience. We do not share your location data with third parties without your consent.</p>


            <h2>Contact Us</h2>
            <p>If you have any questions or concerns about this privacy policy, please contact us at <a href="mailto:info@suyaptech.com">info@suyaptech.com</a>.</p>

            {/* <h2>Effective Date</h2>
            <p>This privacy policy is effective as of June 15, 2024.</p> */}
        </div>
    )
}

export default PrivacyPolicy;